const Constants = {
  WidthContent: '1140px',
  PaddingContent: 'calc(50% - 1140px / 2)',
};

export default Constants;
